export const AppConstatnt = {
    CREDIT_CARD: "CREDITCARD",
    CHECK_PAY: "CHECKPAY",
    RELAY: "RELAY",
    COMCHECK: "COMCHECK",
    EFS: "EFS",
    TCHECK: "TCHECK",
    theme: {
        DARK: 'dark',
        LIGHT: 'light'
    },
    auth: {
        SIGNUP: 'SIGNUP',
        OTP: 'OTP',
        SIGNUPCONFIRM: 'SIGNUPCONFIRM',
        SIGNIN: 'SIGNIN'
    },
    flow: {
        CARRIER: 'Carrier',
        DRIVER: 'Driver'
    },
    comdata_error_code:{
        BALANCE_EXCEEDED:"BALANCE EXCEEDED",
        TRY_CHECK_AUTH:"TRY CHECK AUTH",
        INVALID_CUSTOMER_CODE:"INVALID CUSTOMER CODE",
        INVALID_EXPRESS_CODE:"INVALID EXPRESS CODE",
        INVALID_SEQ_NR: "INVALID SEQ NR",
        INVALID_AMOUNT_REQUESTED:"INVALID AMOUNT REQUESTED"
    },
    comdata_error_response:{
        BALANCEEXCEEDED:'Payment amount exceeded, please try again with lesser amount',
        TRYCHECKAUTH:'Express code is already used, please try with different express code',
        INVALIDCUSTOMERCODE:'Customer code is invalid, please try again',
        INVALIDEXPRESSCODE:'Express code is invalid, please try with different express code',
        INVALIDSEQNR:"Sequence number is invalid",
        INVALIDAMOUNTREQUESTED:"Amount Requested is invalid",
        INVALIDDRIVERNUMBER:"A valid Driver Number is Required. If you require assistance, please contact our Support Contact Center (855) 752-2878.",
        INVALIDTRIPNUMBER:"A valid Trip Number is Required. If you require assistance, please contact our Support Contact Center (855) 752-2878.",
        INVALIDUNITNUMBER:"A valid Unit Number is Required. If you require assistance, please contact our Support Contact Center (855) 752-2878."

    },
    tcheck_error_code:{
        AMOUNT_CODE_INVALID:'AMOUNT CODE INVALID',
        DUPLICATE_INVOICE:'DUPLICATE INVOICE',
        INVALID_MONEY_CODE:'INVALID MONEY CODE',
        AMOUNT_EXCEEDS_BALANCE:'AMOUNT EXCEEDS BALANCE',
        EXPRESS_CODE_NOT_ON_FILE:'EXPRESS CODE NOT ON FILE'
    },
    tcheck_error_response:{
        AMOUNTCODEINVALID:'Express code is invalid, please enter the valid express code',
        DUPLICATEINVOICE:'Invoice is Duplicate',
        INVALIDMONEYCODE:'Money code is invalid , please enter the valid Money Code.',
        AMOUNTEXCEEDSBALANCE:'Payment amount exceeded, please try again with lesser amount',
        CODE46:"Money code have already been used, Please try again with the different Money Code"

    }
}
